import type { Package } from './types'

// the units with a translation in jc.tebex.period (te() can't tell, as it misses precompiled messages)
const units = ['day', 'week', 'month', 'year']

export function useTebexRenewal() {
  const { t } = useI18n()

  // e.g. "every 30 days", or null if the interval is unknown
  const period = (pack: Package) => {
    // expiry_period is undocumented, so the days of our premium packages are the fallback
    const { count, unit } = pack.expiry_period ?? { count: pack.creator_meta_data?.amount ?? 0, unit: 'day' }
    return count > 0 && units.includes(unit) ? t(`jc.tebex.period.${unit}`, count) : null
  }

  // sales only discount the first payment, a subscription renews at the full price
  const renewalPrice = (pack: Package) => pack.base_price + pack.discount

  return { period, renewalPrice }
}
